module.exports = __webpack_public_path__ + "static/media/xueshengzheng.d40b86f7.png";